module.exports = function getResource(label, vars = []) {
    const resources = {
        greeting: 'Hi',
        signIn: 'Sign In',
        signInPrompt: 'for FREE Shipping',
        biHeading: 'Beauty Insider Summary',
        biDesc: 'View activity, savings, benefits',
        biDescUpdated: 'See your loyalty program savings, benefits, rewards',
        biDescJoin: 'Join now to start saving & collect points',
        joinNow: 'Join Now',
        rewardsHeading: 'Rewards Bazaar',
        rewardsDesc: 'Redeem items, samples, more',
        pointsLabel: 'Point',
        chooseBirthdayGift: 'Choose your Birthday gift!',
        ccHeading: 'Sephora Credit Card Program',
        ccDesc: 'Manage credit card and rewards',
        ccDescUpdated: 'View and manage credit card and rewards',
        ccRewardsLabel: 'Rewards',
        ccApplyNow: 'Apply now',
        ordersHeading: 'Orders',
        ordersDesc: 'View & track online or pickup orders',
        autoReplenishHeading: 'Auto-Replenish',
        autoReplenishDesc: 'View and manage your subscriptions',
        purchasesHeading: 'Buy It Again',
        purchasesDesc: 'Reorder from in-store and online purchases',
        lovesHeading: 'Loves',
        lovesDesc: 'View saved products',
        recHeading: 'Beauty Advisor Recommendations',
        recDesc: 'Recommendations from your store visits',
        reservationsHeading: 'Reservations',
        reservationsDesc: 'Manage your services, classes, events',
        ciqHeading: 'Beauty Traits & Color iQ',
        ciqDesc: 'Complete your beauty traits for personalized recommendations',
        beautyPrefHeading: 'Beauty Preferences',
        beautyPrefDesc: 'Complete to see your personalized recommendations',
        accountHeading: 'Account Settings',
        accountDesc: 'Payment, contact info, addresses, password',
        signOut: 'Sign Out',
        flashHeading: 'Flash',
        flashDesc: 'Unlimited 1-2 Day Shipping Subscription',
        beautyPrefNotif: 'NEW! Personalize your shopping experience.',
        sameDayUnlimitedHeading: 'Same-Day Unlimited',
        sameDayUnlimitedMemberDesc: 'Manage your subscription',
        sameDayUnlimitedNonMemberDesc: 'Get Unlimited Free Same-Day Delivery',
        subscribeToday: 'Subscribe today'
    };

    return resources[label];
};
